import { FilterMode } from "./Filtermode";
import BasicGrid from "./Grid";


const BarCodeLiquidationAgeingAll = () => {


  return (
    <>
      <FilterMode  />
      <BasicGrid  />
    </>
  );
};

export default BarCodeLiquidationAgeingAll;